import React from "react";
import PersonalisationIcon from "../../Components/CustomerServices/PersonalisationIcon";
import HowItWorks from "../../Components/CustomerServices/Personalisation/HowItWorks";
import styles from "./Personalisation.module.css";
import SharedCS from "./SharedCS";
import CanBePersonalised from "../../Components/Shared/Icons/CanBePersonalised";
import Splotch from "../../Components/Shared/Icons/Splotch";
import NeedleIron from "../../Components/Shared/Icons/NeedleIron";
import Blocks from "../../Components/Shared/Icons/Blocks";
import * as Fa from "react-icons/fa";
import ShopActions from "../../Components/Shared/ShopActions/ShopActions";
import { Link } from "react-router-dom";
import Connected from "../../Components/Home/Connected/Connected";
import ConnectedImages from "../../Components/Home/Connected/ConnectedImages";
import commonStyles from "../../Components/Shared/commonStyles.module.css";
import WhatPersonal from "../../Components/CustomerServices/Personalisation/WhatPersonal";
import Considerations from "../../Components/CustomerServices/Personalisation/Considerations";
import PersonalisationCTA from "../../Components/CustomerServices/Personalisation/PersonalisationCTA";

const Personalisation = () => (

    <div className={commonStyles.section}>
      <div className={commonStyles.container}>
        <div className={commonStyles.sectionHeaderContainer}>
          <h2 className={commonStyles.sectionHeader}>Personalise Your Gift</h2>
          <p className={commonStyles.paragraph}>
            Make your gift as unique as the person receiving it. Add names,
            messages, or designs to create something truly special.
          </p>
        </div>
        <div className={styles.Hero}>
          <WhatPersonal />
          <div className={styles.HeroImg}>
            <img src="/Images/Items/Chef-Cooking-Apron/Chef-Cooking-Apron-2.jpg" />
          </div>
        </div>
        <HowItWorks />
        <Considerations />
        <PersonalisationCTA />
      </div>
    </div>

);

export default Personalisation;
